import { z } from 'zod';

export const integrationSchema = z.object({
  id: z.string(),
  provider: z.string(),
  status: z.enum(['NOT_CONFIGURED', 'DISABLED', 'CONNECTED', 'ERROR', 'SYNCING']),
  is_enabled: z.boolean(),
  has_credentials: z.boolean().default(false),
  last_sync_at: z.string().nullable().optional(),
  last_success_at: z.string().nullable().optional(),
  last_error: z.string().nullable().optional(),
});

export const syncRunSchema = z.object({
  id: z.string(),
  status: z.string(),
  started_at: z.string(),
  finished_at: z.string().nullable().optional(),
  records_received: z.number(),
  records_written: z.number(),
  error: z.string().nullable().optional(),
});

export const integrationUnitMappingSchema = z.object({
  id: z.string(),
  external_id: z.string(),
  external_name: z.string().nullable().optional(),
  business_unit_id: z.string(),
});

export const integrationDetailSchema = integrationSchema.extend({
  unit_mappings: z.array(integrationUnitMappingSchema).default([]),
  sync_runs: z.array(syncRunSchema).default([]),
});

export const reconciliationSchema = z.object({
  status: z.string(),
  configured: z.boolean(),
  year: z.number().nullable().optional(),
  month: z.number().nullable().optional(),
  rows: z
    .array(
      z.object({
        business_unit_id: z.string(),
        business_unit_name: z.string(),
        metric: z.string(),
        iiko_value: z.string().nullable(),
        opu_value: z.string().nullable(),
        difference: z.string().nullable(),
        difference_percent: z.string().nullable(),
      }),
    )
    .default([]),
  message: z.string(),
});

export type Integration = z.infer<typeof integrationSchema>;
export type IntegrationDetail = z.infer<typeof integrationDetailSchema>;
export type Reconciliation = z.infer<typeof reconciliationSchema>;

export const INTEGRATION_STATUS_LABELS: Record<Integration['status'], string> = {
  NOT_CONFIGURED: 'Не подключено',
  DISABLED: 'Отключено',
  CONNECTED: 'Подключено',
  ERROR: 'Ошибка',
  SYNCING: 'Синхронизация',
};
